import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import image from '../../../assets/images/whiky_house/-NYxTxbMew2iGaQCmrZF'
import "./card_slide.css";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShoppingCart,
} from "react-icons/ai";

const NextArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-right-10 shadow-md bg-white p-4 rounded-full md:right-4 top-[47%]"
    >
      <AiOutlineArrowRight />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-left-10 shadow-md bg-white p-4 rounded-full md:-left-10 left-3 z-50 top-[47%] "
    >
      <AiOutlineArrowLeft />
    </div>
  );
};

const CardSlide = ({ SlideData, title }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // centerMode: ,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <div className=" mt-10">
        <h1 className=" text-center mb-6 text-[22.5px] px-10 titlefont font-medium ">
          {title}
        </h1>
      </div>
      <div className="md:px-8">
        <Slider {...settings}>
          {SlideData?.map((item) => (
            <div class="relative m-10 w-full max-w-xs overflow-hidden 
            rounded-lg bg-white shadow-md">
              <a href="#">
                <img
                  class="h-60 rounded-t-lg object-cover w-full"
                  src={item.img}
                  alt="product image"
                />
              </a>
              <span class="absolute top-0 left-0 w-28 translate-y-4 -translate-x-6 -rotate-45 bg-black text-center text-sm text-white">
                Sale
              </span>
              <div class="mt-4 px-5 pb-5 ">
                <a href="#">
                  <h5 class="text-lg font-semibold mb-4 tracking-tight text-slate-900">
                    {item.name}
                  </h5>
                </a>

                <div class="flex items-center justify-between ">
                  <p>
                    <span class="text-base font-bold text-slate-900">
                      {item.price} MMK
                    </span>
                    <span class="text-sm text-slate-900 line-through">
                      $299
                    </span>
                  </p>
                  <a
                    href="#"
                    class="flex items-center rounded-md bg-slate-900 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-blue-300"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="mr-2 h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                    Add to cart
                  </a>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default CardSlide;
